import React from "react";
import { OPERATION_LIST, getOperation } from "../../dataScienceOperations";
import type { DataOperationConfig as OpConfig } from "../../dataScienceOperations";

import Select from "../ReusableComponents/Select";
interface Props {
  operation: OpConfig | null;
  onChange: (next: OpConfig | null) => void;
}

const DataOperationConfig: React.FC<Props> = ({ operation, onChange }) => {
  const selectedOp = getOperation(operation?.id);

  const handleOpChange = (id: string) => {
    if (!id) {
      onChange(null);
      return;
    }
    const op = getOperation(id);
    if (!op) {
      onChange(null);
      return;
    }
    onChange({ id: op.id, args: op.defaultArgs, version: 1 });
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="eai-meta-label mb-2 block">Data Operation</label>
        <Select
          value={operation?.id ?? ""}
          onChange={(e) => handleOpChange(e.target.value)}
          containerClassName="w-full"
        >
          <option value="">None</option>
          {OPERATION_LIST.map((op) => (
            <option key={op.id} value={op.id}>
              {op.displayName}
            </option>
          ))}
        </Select>
      </div>

      {selectedOp && operation && (
        <>
          <p className="font-inter text-eai-body-xs leading-relaxed text-eai-ink-subtle">{selectedOp.description}</p>
          <selectedOp.ArgsForm
            args={operation.args}
            onChange={(args) => onChange({ ...operation, args })}
          />
        </>
      )}
    </div>
  );
};

export default DataOperationConfig;
